import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '@env';
import { WindowService } from '@shared/services/window.service';

@Component({
  selector: 'app-unavailable-feature',
  templateUrl: './unavailable-feature.component.html',
  styleUrls: ['./unavailable-feature.component.scss']
})
export class UnavailableFeatureComponent {
  @Input() image: string = "";
  @Input() attention: string = "";
  @Input() descriptionTitle: string = "";
  @Input() descriptionContent: string = "";

  @Output() cancelCallback = new EventEmitter();

  constructor(
    private windowService: WindowService
  ) { }

  cancel(): void {
    this.cancelCallback.emit();
  }

  choosePlan(): void {
    alert('TODO');
  }
}
